import { MigrationSpec } from "../migration.models"

/**
 * Operator's reporting reads (QPIEN-1407) narrow these collections by tenant and date. One row per
 * collection so the page shows each index's own status; api-v2 builds them all the same way
 * (`OPERATOR_INDEX_MIGRATIONS`), so the list here must match that one.
 */
const INDEXES: {
  type: string
  collection: string
  keys: Record<string, 1 | -1>
}[] = [
  {
    type: "OPERATOR_INDEX_MESSAGE_HISTORY",
    collection: "MessageHistory",
    keys: { customer: 1, createdAt: 1 }
  },
  {
    type: "OPERATOR_INDEX_CONVERSATION_TAG_HISTORY",
    collection: "ConversationTagHistory",
    keys: { customer: 1, createdAt: 1 }
  },
  {
    type: "OPERATOR_INDEX_SURVEY_HISTORY",
    collection: "SurveyHistory",
    keys: { customer: 1, createdAt: 1 }
  },
  {
    type: "OPERATOR_INDEX_CAMPAIGN_HISTORY",
    collection: "CampaignHistory",
    keys: { customer: 1, createdAt: 1 }
  },
  {
    type: "OPERATOR_INDEX_CUSTOMER_PERSON_HISTORIES",
    collection: "CustomerPersonHistories",
    keys: { customer: 1, createdAt: 1 }
  },
  {
    type: "OPERATOR_INDEX_TASKS",
    collection: "Tasks",
    keys: { customerId: 1, dueAt: 1 }
  },
  {
    type: "OPERATOR_INDEX_TASK_LOG",
    collection: "TaskLog",
    keys: { task: 1, createdAt: -1 }
  }
]

const operatorReportingIndexes: MigrationSpec[] = INDEXES.map(
  ({ type, collection, keys }) => ({
    type,
    collection,
    risk: "INDEX",
    title: {
      en: `Operator reports: ${collection} index`,
      tr: `Operator raporları: ${collection} indeksi`
    },
    description: {
      en:
        `Creates the ${JSON.stringify(keys)} index on ${collection}, which Operator's reporting tools ` +
        "and the panel's history statistics filter on. Skipped when the index already exists.",
      tr:
        `${collection} koleksiyonunda ${JSON.stringify(keys)} indeksini kurar; Operator'ün rapor ` +
        "araçları ve panelin geçmiş istatistikleri bu alanlarla filtreler. İndeks zaten varsa dokunmaz."
    },
    affectedFilter: { _id: null },
    sampleFields: [keys.dueAt ? "dueAt" : "createdAt"],
    indexes: { mustExist: [{ keys }] },
    notes: [
      {
        en:
          "api-v2 declares this index on its schema and autoIndex is on, so a boot may already have " +
          "built it; the status shows whether it exists. Building it on a large collection takes a while.",
        tr:
          "api-v2 bu indeksi şemasında tanımlıyor ve autoIndex açık; bir açılış onu zaten kurmuş olabilir, " +
          "durum sütunu var olup olmadığını gösterir. Büyük bir koleksiyonda kurulum biraz sürer."
      }
    ]
  })
)

export default operatorReportingIndexes
